(function(api, CONSTANTS){
  "use strict";
  window.dfPlatform = {
    /**
     * Responsible for creating an anonymous user
     * @param {object} params - the url params
     * @param {string} params.p1 - the GUID
     * @param {string} params.p2 - the value 'vgFP89AJ7bX9KW5p' without quotes
     * @param {string} params.p3 - the selected language 'EN' or 'ES'
     * @param {string} params.p4 - the selected_role (from user selection). Note that: all special characters changed to _
     * @param {string} [params.utm_source] - the utm source value
     * @param {string} [params.utm_medium] - the utm medium value
     * @param {string} [params.utm_campaign] - the utm campaign value
     * @param {string} [params.utm_term] - the utm term value
     * @returns {Promise<Response>}
     */
    createAnonymousUser: function(params){
      const urlParams = api.toFormUrlEncoded(params);
      console.log('[dfPlatform.createAnonymousUser] Called with params:', params);
      console.log('[dfPlatform.createAnonymousUser] URL params string:', urlParams);
      console.log('[dfPlatform.createAnonymousUser] Full URL:', `${CONSTANTS.apiHost}/jsonWeb.asmx/H20099?${urlParams}`);
      return window.dfPlatform.prepareRequest(fetch(`${CONSTANTS.apiHost}/jsonWeb.asmx/H20099?${urlParams}`));
    },
    /**
     * Responsible for sending a PIN code and verifying a provided phone number.
     * @param {object} params - the url params
     * @param {string} params.p1 - the GUID
     * @param {string} params.p2 - the value 'vgFP89AJ7bX9KW5p' without quotes
     * @param {string} params.p3 - 10 digit phone number
     * @param {string} params.p4 - the value CONNECT/JOIN to add/verify phone number
     * @param {string} params.p5 - PIN code provided by the user
     * @returns {Promise<Response>}
     */
    sendPhoneVerificationRequest: function(params){
      const urlParams = api.toFormUrlEncoded(params);
      return window.dfPlatform.prepareRequest(fetch(`${CONSTANTS.apiHost}/jsonWeb.asmx/H20098?${urlParams}`));
    },
    /**
     * Responsible for fetching feedback from the Platform API
     * @param {object} params - the url params
     * @param {string} params.p1 - encoded subscriber value
     * @param {string} params.p2 - the GUID
     * @param {string} params.p3 - the value H
     * @returns {Promise<Response>}
     */
    fetchInstantFeedback: function(params){
      const urlParams = api.toFormUrlEncoded(params);
      return window.dfPlatform.prepareRequest(fetch(`${CONSTANTS.apiHost}/jsonWeb.asmx/H21006?${urlParams}`));
    },
    /**
     * Responsible for starting an AI session for Risk Assessment
     * @param {object} params - the url params
     * @param {string} params.p1 - random GUID
     * @param {string} params.p2 - hex-encoded user-id returned from H20099
     * @param {string} params.p3 - assistant-Id (should be 'RISK')
     * @param {string} params.p4 - request (initial request is empty string "")
     * @returns {Promise<Response>}
     */
    startAISession: function(params){
      const urlParams = api.toFormUrlEncoded(params);
      console.log('[dfPlatform.startAISession] Called with params:', params);
      console.log('[dfPlatform.startAISession] URL params string:', urlParams);
      console.log('[dfPlatform.startAISession] Full URL:', `${CONSTANTS.apiHost}/jsonWeb.asmx/H21006AI?${urlParams}`);
      return window.dfPlatform.prepareRequest(fetch(`${CONSTANTS.apiHost}/jsonWeb.asmx/H21006AI?${urlParams}`));
    },
    /**
     * Responsible for fetching AI streaming results
     * @param {object} params - the url params
     * @param {string} params.p1 - random GUID
     * @param {string} params.p2 - stream_response_id from H21006AI
     * @param {string} params.p3 - stream_offset_count (bytes received so far)
     * @returns {Promise<Response>}
     */
    fetchAIStream: function(params){
      const urlParams = api.toFormUrlEncoded(params);
      console.log('[dfPlatform.fetchAIStream] Called with params:', params);
      console.log('[dfPlatform.fetchAIStream] URL params string:', urlParams);
      console.log('[dfPlatform.fetchAIStream] Full URL:', `${CONSTANTS.apiHost}/jsonWeb.asmx/H21007AI?${urlParams}`);
      return window.dfPlatform.prepareRequest(fetch(`${CONSTANTS.apiHost}/jsonWeb.asmx/H21007AI?${urlParams}`));
    },
    /**
     * Responsible for closing the AI stream
     * @param {object} params - the url params
     * @param {string} params.p1 - random GUID
     * @param {string} params.p2 - stream_response_id from H21006AI
     * @param {string} params.p3 - request_id from H21006AI
     * @returns {Promise<Response>}
     */
    closeAIStream: function(params){
      const urlParams = api.toFormUrlEncoded(params);
      console.log('[dfPlatform.closeAIStream] Called with params:', params);
      console.log('[dfPlatform.closeAIStream] URL params string:', urlParams);
      console.log('[dfPlatform.closeAIStream] Full URL:', `${CONSTANTS.apiHost}/jsonWeb.asmx/H21008AI?${urlParams}`);
      return window.dfPlatform.prepareRequest(fetch(`${CONSTANTS.apiHost}/jsonWeb.asmx/H21008AI?${urlParams}`));
    },
    /**
     * Responsible for sending a POST request to the Platform API, specifying endpoint and params
     * @param {string} endpoint - the endpoint to send the request to
     * @param {object} params - the url params
     * @returns {Promise<Response>}
     */
    sendPlatformPOSTRequest: function(endpoint, params){
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      };
      return fetch(`${CONSTANTS.apiHost}/jsonWeb.asmx/${endpoint}`, requestOptions).then(response => {
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
        return response;
      });
    },
    /**
     * Responsible for generating a verification code for an SMS OSC Meeting Reminder request
     * @param {object} params - the url params
     * @param {string} params.p1 - Meeting ID
     * @param {number} params.p2 - 10 digit phone number
     * @param {string} params.p3 - GUID
     * @param {string} params.p4 - the value "4f53432d4f534d"
     * @param {string} params.p5 - Language code ("EN" or "ES")
     * @param {number} params.p6 - Master account ID (the value: 1)
     * @returns {Promise<Response>}
     */
    requestOSCReminderViaSMS: function(params){
      const urlParams = api.toFormUrlEncoded(params);
      return window.dfPlatform.prepareRequest(fetch(`${CONSTANTS.apiHost}/jsonWeb.asmx/H20097?${urlParams}`));
    },
    /**
     * Responsible for performing phone verification for an SMS OSC Meeting Reminder request
     * @param {object} params - the url params
     * @param {string} params.p1 - ID returned by verification request
     * @param {number} params.p2 - the value "4f534d636865636b"
     * @param {string} params.p3 - 4 digits PIN Code
     * @param {string} params.p4 - Master account ID (the value: 1)
     * @param {string} params.p5 - Meeting ID
     * @returns {Promise<Response>}
     */
    verifyOSCReminderViaSMS: function(params){
      const urlParams = api.toFormUrlEncoded(params);
      return window.dfPlatform.prepareRequest(fetch(`${CONSTANTS.apiHost}/jsonWeb.asmx/H20096?${urlParams}`));
    },
    /**
     * Responsible for handling default processing of API requests which return XML
     * @param {Promise} fetchCall - Promise coming from fetch API request
     * @returns {*}
     */
    prepareRequest: function(fetchCall){
      return fetchCall.then(response => {
        console.log('[dfPlatform.prepareRequest] Response status:', response.status);
        console.log('[dfPlatform.prepareRequest] Response headers:', response.headers);
        return response.text();
      })
          .then(xmlString => {
            console.log('[dfPlatform.prepareRequest] Raw XML response:', xmlString);
            return jQuery.parseXML(xmlString);
          })
          .then($xml => {
            const jsonString = jQuery($xml).find('string').text();
            console.log('[dfPlatform.prepareRequest] Extracted JSON string:', jsonString);
            const parsedJSON = JSON.parse(jsonString);
            console.log('[dfPlatform.prepareRequest] Parsed JSON:', parsedJSON);
            return parsedJSON;
          });
    }
  }
})(window.dfApi, window.dfCONSTANTS);